import React from "react"
import PropTypes from "prop-types"

import css from "./PrimaryButton.scss"

function PrimaryButton(props) {
    const { isDisabled, isOutlined, onClick, label, iconUrl, rightIconUrl } = props
    const className = [
        css.button,
        "",
        isOutlined ? css.outlined : "",
        isDisabled && isOutlined ? css.disabledOutline : "",
        isDisabled && !isOutlined ? css.disabled : "",
    ].join(" ")
    return (
        <button className={className} onClick={onClick} disabled={isDisabled}>
            {iconUrl ? <img src={iconUrl} className={css.imageSpan} alt="Icon" title="button" /> : null}
            <span className={`bodySemiBold ${css.btnText}`}>{label}</span>
            {rightIconUrl ? (
                <img src={rightIconUrl} className={css.rightImageSpan} alt="Icon" title="button" />
            ) : null}
        </button>
    )
}

PrimaryButton.propTypes = {
    isDisabled: PropTypes.bool,
    isOutlined: PropTypes.bool,
    onClick: PropTypes.func,
    iconUrl: PropTypes.string,
    rightIconUrl: PropTypes.string,
    label: PropTypes.string.isRequired,
}

PrimaryButton.defaultProps = {
    label: "Button",
}

export default PrimaryButton
